import { Button } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';

const ButtonStyle = styled(Button)(({ theme }) => ({
  '&:hover': {
    background: theme.palette.primary.contrastText,
  },
  background: theme.palette.primary.contrastText,
  borderRadius: '25px',
  color: 'white',
  display: 'grid',
  height: 100,
  justifyItems: 'center',
  width: 100,
}));

type PropsTypes = {
  icon: React.ReactNode;
  title: string;
  onClick?: any;
};

export default function CustomizeButton(props: PropsTypes) {
  const { icon, title, onClick } = props;
  return (
    <ButtonStyle onClick={onClick}>
      {icon}
      {title}
    </ButtonStyle>
  );
}
